import script from "./acompanhamento-cozinha.vue?vue&type=script&setup=true&lang=js"
export * from "./acompanhamento-cozinha.vue?vue&type=script&setup=true&lang=js"

import "./acompanhamento-cozinha.vue?vue&type=style&index=0&id=78b50a36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78b50a36"]])

export default __exports__